import { RcFile } from 'antd/lib/upload';
import { call, put } from 'redux-saga/effects';
import { OrderItemSearchService } from '../../../services/OrderItemSearch';
import { ILongSteelOrderItem } from '../long-steel-shopping-cart/types';
import { ECodeType, IOrderEntryPreference } from '../user/types';
import {
  loadLastOrdersFailure,
  loadLastOrdersSuccess,
  searchItemFailure,
  searchItemsSpreadsheetFailure,
  searchItemsSpreadsheetSuccess,
  searchItemSuccess,
  searchItemsFromLastOrderSuccess,
  searchItemsFromLastOrderFailure,
  faceliftSearchItemSuccess,
  faceliftSearchItemFailure,
  spreadsheetItemsExceeded
} from './actions';
import { ILastOrder, Types } from './types';
import { addToast } from '../toast/actions';
import { EToastTypes } from '../toast/types';
import { handleCopyAndEmail } from '../../../utils/formatStrings';

interface ISearchItemsParams {
  payload: {
    customerId: string;
    searchTerm: string;
    orderEntryPreference: IOrderEntryPreference;
    codeType: ECodeType;
    file: RcFile;
    userId: string;
    selectedLastOrder: ILastOrder;
    customerState: string;
  };
  type: Types;
}

interface SpreadSheetMVPParams {
  payload: {
    emitterId: string;
    codeType: ECodeType;
    file: RcFile;
    orderEntryPreference: IOrderEntryPreference;
    division: string[];
    customerState: string;
  };
  type: Types;
}

export function* searchItemsSaga(params: ISearchItemsParams) {
  try {
    const orderItemSearchSvc = new OrderItemSearchService();

    const { customerId, searchTerm, codeType, customerState } = params.payload;

    const searchedItems: ILongSteelOrderItem[] = yield call(
      orderItemSearchSvc.searchItems.bind(orderItemSearchSvc),
      customerId,
      searchTerm,
      codeType,
      customerState
    );

    yield put(searchItemSuccess(searchedItems));
  } catch (err) {
    console.error('searchItemSaga', err);
    yield put(searchItemFailure(err));
  }
}

export function* faceliftSearchItemsSaga(params: ISearchItemsParams) {
  try {
    const orderItemSearchSvc = new OrderItemSearchService();

    const { customerId, searchTerm, codeType, customerState } = params.payload;

    const searchedItems: ILongSteelOrderItem[] = yield call(
      orderItemSearchSvc.searchItems.bind(orderItemSearchSvc),
      customerId,
      searchTerm,
      codeType,
      customerState
    );
    yield put(faceliftSearchItemSuccess(searchedItems));
  } catch (err) {
    console.error('faceliftsearchItemSaga', err);
    yield put(faceliftSearchItemFailure(err));
  }
}

export function* searchItemsSpreadsheetSaga(params: ISearchItemsParams) {
  try {
    const { customerId, orderEntryPreference, file, customerState } =
      params.payload;

    const orderItemSearchSvc = new OrderItemSearchService();

    const searchedItems: ILongSteelOrderItem[] = yield call(
      orderItemSearchSvc.searchItemsBySpreadsheet.bind(orderItemSearchSvc),
      customerId,
      orderEntryPreference,
      file,
      customerState
    );

    yield put(searchItemsSpreadsheetSuccess(searchedItems));
  } catch (err) {
    console.error('searchItemsSpreadsheetSaga', err);
    yield put(searchItemsSpreadsheetFailure(err));
    yield put(
      addToast({
        message:
          'Ocorreu um erro inesperado, tente novamente em alguns instantes. Se o problema persistir, entre em contato com o suporte',
        type: EToastTypes.DANGER,
        labelActionOne: 'CONTATAR SUPORTE',
        handleClickActionOne: handleCopyAndEmail,
        durationInMS: 5000,
        spaceToTop: 80
      })
    );
  }
}

export function* searchItemsSpreadSheetSagaMVP(params: SpreadSheetMVPParams) {
  try {
    const { emitterId, orderEntryPreference, file, customerState } =
      params.payload;
    const orderItemSearchSvc = new OrderItemSearchService();
    let itemsNotSent: ILongSteelOrderItem[] = [];
    const setItemsNotSend = (arr: ILongSteelOrderItem[]) =>
      (itemsNotSent = arr);
    const searchedItems: ILongSteelOrderItem[] = yield call(
      orderItemSearchSvc.searchItemsBySpreadsheetMvp.bind(orderItemSearchSvc),
      emitterId,
      orderEntryPreference,
      file,
      customerState,
      setItemsNotSend
    );

    // const skuList: string[] = yield call(
    //   [searchedItems, 'map'],
    //   (si: ILongSteelOrderItem) => si.sku
    // );

    // const gSvc = new EGerdauService();
    // const headers: IHeaderRequest = yield call(gSvc.getHeaders.bind(gSvc));

    // const magentoProduct: AxiosResponse<MultProductsResponse[]> = yield call(
    //   customersAuthorizationApi.get,
    //   `${EndpointsMvp.SEARCH_MULT_PRODUCTS(
    //     skuList,
    //     codeType,
    //     emitterId,
    //     skuList.length,
    //     1,
    //     division
    //   )}`,
    //   { headers }
    // );

    // const filteredSearchedItems: ILongSteelOrderItem[] = yield call(
    //   [searchedItems, 'map'],
    //   (loi: ILongSteelOrderItem) => {
    //     const magProd = magentoProduct.data.find((mp) => mp.sku === loi.sku);
    //     if (!magProd || loi.preValidation) {
    //       return {
    //         ...loi,
    //         found: false,
    //         code: '10',
    //         description: SPREADSHEET_PRODUCT_NOT_FOUND,
    //         message: SPREADSHEET_PRODUCT_NOT_FOUND,
    //         quantity: 0
    //       } as ILongSteelOrderItem;
    //     }
    //     return loi;
    //   }
    // );

    yield put(searchItemsSpreadsheetSuccess(searchedItems));
    yield put(
      spreadsheetItemsExceeded(itemsNotSent.length + searchedItems.length > 30)
    );
  } catch (err) {
    console.error('searchItemsSpreadsheetSaga', err);
    yield put(searchItemsSpreadsheetFailure(err));
    yield put(
      addToast({
        message:
          'Ocorreu um erro inesperado, tente novamente em alguns instantes. Se o problema persistir, entre em contato com o suporte',
        type: EToastTypes.DANGER,
        labelActionOne: 'CONTATAR SUPORTE',
        handleClickActionOne: handleCopyAndEmail,
        durationInMS: 5000
      })
    );
  }
}

export function* loadLastOrdersSaga(params: ISearchItemsParams) {
  try {
    const { customerId } = params.payload;

    const orderItemSearchSvc = new OrderItemSearchService();

    const lastOrders: ILastOrder[] = yield call(
      orderItemSearchSvc.searchLastOrders.bind(orderItemSearchSvc),
      customerId
    );

    yield put(loadLastOrdersSuccess(lastOrders));
  } catch (err) {
    console.error('loadLastOrdersSaga', err);
    yield put(loadLastOrdersFailure(err));
  }
}

export function* searchItemsFromLastOrderSaga(params: ISearchItemsParams) {
  try {
    const { selectedLastOrder, customerState } = params.payload;

    const orderItemSearchSvc = new OrderItemSearchService();

    const items: ILongSteelOrderItem[] = yield call(
      orderItemSearchSvc.searchItemsFromLastOrder.bind(orderItemSearchSvc),
      selectedLastOrder,
      customerState
    );

    yield put(searchItemsFromLastOrderSuccess(items));
  } catch (err) {
    console.error('searchItemsFromLastOrder', err);
    yield put(searchItemsFromLastOrderFailure(err));
  }
}
